import { useMemo } from 'react';

import {
  Configuration,
  DefaultApi,
  type Organization,
  type ResponseError,
} from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '@packages/legacy/auth';

export const getOrganizationQueryKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-organization',
];

export const useOrganization = (
  organizationId: string,
  rendallUrl: string,
  options?: Omit<
    UseQueryOptions<Organization, ResponseError>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetchApi } = useAuthContext();

  const api = useMemo(() => {
    return new DefaultApi(
      new Configuration({
        basePath: rendallUrl,
        fetchApi,
      }),
    );
  }, [fetchApi, rendallUrl]);

  return useQuery<Organization, ResponseError>({
    queryFn: () => api.getOrganization({ organizationId }),
    queryKey: getOrganizationQueryKey(organizationId),
    ...options,
    enabled: !!organizationId && !!rendallUrl,
  });
};
